module.exports = __webpack_public_path__ + "img/example-03-processed.6cafcf33.png";